<template>
    <html>
    <body style="position: relative;background: #fff" v-loading="loading">
        <!--banner-->
        <div class="nbanner" v-if="$util.isEmpty(keyword)"> <img src="@/assets/styles/images/ny8.png" alt=""> </div>
        <!--主体开始-->
        <div class="nding" v-if="!$util.isEmpty(keyword)">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/purchase/list">供求广场</a>&gt;<a href="/supply/list">供应信息</a>&gt; <a href="">{{keyword}}</a>
                <p style="float: right">共找到{{count}}条“{{keyword}}”供应信息</p>
                
            </div>
        </div>
        <div class="fenlei">
            <div class="xia1" style="display: flex;flex-direction: row;justify-content: space-between">
                <ul class="poster-txt xg" style="height: 40px;">
                    <h4>地区</h4>
                    <div>
                        <li><a :class="$util.isEmpty(areacode) ? 'on' : ''" href="javascript:void(0)" @click="changeArea('')">不限</a></li>
                        <li v-for="item in areas" :key="item.id"><a :class="item.id == areacode ? 'on' : ''" href="javascript:void(0)" @click="changeArea(item.id)">{{item.shortname}}</a></li>
                    </div>
                </ul>
                <div class="poster-btn"><a href="javascript:void(0);">展开更多</a></div>
            </div>
        </div>
        <div class="fenlei" style="border: #e5e5e5 1px solid">
            <ul class="sh">
                <li><a :class="$util.isEmpty(category_id) ? 'on' : ''" href="javascript:void(0)" @click="alltypes()">全部</a></li>
                <li v-for="item in categoryList" :key="item.category_id"><a :class="item.category_id == category_id_1 ? 'on' : ''" @click="getChild(item.category_id)" href="javascript:void(0)">{{item.category_name}}</a></li>
            </ul>
            <div class="xia1">
                <ul v-for="item in childList" :key="item.category_id">
                    <h4>{{item.category_name}}</h4>
                    <div>
                        <li v-for="i in item.child_list" :key="i.category_id"><a :class="i.category_id == category_id ? 'on' : ''" href="javascript:void(0);" @click="getAttr(i.category_id, i.attr_class_id)" >{{i.category_name}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <div class="fenlei" style="border: #e5e5e5 1px solid" v-if="isshow"> 
            <div class="xia1">
                <ul>
                    <h4>品种</h4>
                    <div>
                        <li v-for="item in attrList" :key="item.attr_value_id"><a :class="attr_id == item.attr_value_id ? 'on' : ''" href="javascript:void(0);" @click="changeAttr(item.attr_value_id)">{{item.attr_value_name}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <section class="section ncontainer1">
            <ul class="tab-menu">
                <a href="/purchase/list"><li>求购信息</li></a>
                <a href=""><li class="active">供应信息</li></a>
            </ul>
            <div class="tj3">
                <div class="loop_top">
                    <ol class="head">
                        <li>供应品类</li>
                        <li>供应价格</li>
                        <li>所在地 </li>
                        <li>发布人 </li>
                        <li>详情 </li>
                    </ol>
                    <ul class="list">
                        <li v-for="item in pageData" :key="item.id">
                            <a :href="'/supply/details?id='+item.id">
                                <span>{{item.categoryname}}{{!$util.isEmpty(item.attr_value_name) ? '(' + item.attr_value_name + ')' : ''}}</span>
                                <span style="color:#d60000;font-weight:bold">{{item.price}} {{item.unit}}</span>
                                <span>{{item.areaname}}</span>
                                <span>{{item.username}}</span>
                                <span> 查看详情</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="pages">
                <div class="Pagination"></div>
                <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
            </div>
        </section>
    </body>
</html>
</template>
<style scoped>
    .ncontainer1 .tj3 .loop_top .head li:nth-child(2){width: 15%;}
    .ncontainer1 .tj3 .loop_top .head li:nth-child(4){width: 15%;}
    .ncontainer1 .tj3 .loop_top .head li:nth-child(5){width: 10%;}
    .ncontainer1 .tj3 .loop_top .head li:nth-child(3){width: 36%;margin: 0 2%;}
    .ncontainer1 .tj3 .loop_top .list li a span:nth-child(2){width: 15%;}
    .ncontainer1 .tj3 .loop_top .list li a span:nth-child(4){width: 15%;}
    .ncontainer1 .tj3 .loop_top .list li a span:nth-child(5){width: 10%;}
    .ncontainer1 .tj3 .loop_top .list li a span:nth-child(3){width: 36%;margin: 0 2%;}
</style>

<script>
    import '@/assets/styles/js/jquery.pagination.js';
    import { supplyPage } from '@/api/supply/supply';
    import { getArea } from '@/api/address';
    import { getMenuList } from '@/api/goods/goodscategory';
    import { tree } from '@/api/goods/goodscategory';
    import { getAttrValueList } from '@/api/goods/goodscategory';

    export default {
        name: '',
        components: {},
        data: () => {
            return {
                loading: true,
                pageData:[],
                pageCount:0,
                page_size:10,
                page:1,
                areas:[],
                areacode:'',
                attr_id:'',
                category_id:'',
                category_id_1:'',
                categoryList:[],
                childList:[],
                attrList:[],
                isshow:false,
                keyword:'',
                count:0
            };
        },
        created() {
            $(function(){
                $(".poster-btn").click(function(){
                    if ($(this).text() == "展开更多") {
                        $(this).html('<a href="javascript:void(0);">点击收起</a>');
                        $(this).siblings(".poster-txt").removeClass("xg").css("height","auto");
                        $(this).addClass('current-menu').siblings().removeClass('current-menu');
                    }else{
                        $(this).html('<a href="javascript:void(0);">展开更多</a>');
                        $(this).siblings(".poster-txt").addClass("xg").css("height","40px");
                        $(this).removeClass('current-menu').siblings().addClass('current-menu');
                    }
                });
            })
            this.keyword = this.$route.query.keyword;
            this.getsupplyPage();
            this.getAreas();
            this.getTrees();
        },

        methods: {
            getsupplyPage() {
                supplyPage({
                    page_size: this.page_size,
                    page: this.page,
                    areacode: this.areacode,
                    category_id: this.category_id,
                    attr_value_id: this.attr_id,
                    keyword: this.keyword,
                }).then(res => {
                    if(res.code == 0) {
                        this.count = res.data.count;
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changepage
                        });
                        $(".allPage").text(this.pageCount);
                        this.pageData = res.data.list;
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                })
            },
            changepage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                supplyPage({
                    page_size: this.page_size,
                    page: this.page,
                    areacode: this.areacode,
                    category_id: this.category_id,
                    attr_value_id: this.attr_id,
                    keyword: this.keyword,
                }).then(res => {
                    if(res.code == 0) {
                    this.pageData = res.data.list;
                    this.loading = false;
                    }
                });
            },
            getAreas() {
                getArea({

                }).then(res => {
                    if(res.code == 0) {
                        this.areas = res.data;
                    }
                })
            },
            getTrees() {
                tree({
                    level:1
                }).then(res => {
                    if(res.code == 0) {
                        this.categoryList = res.data;
                        // if(this.categoryList.length>0) {
                        //     this.getChild(this.categoryList[0].category_id);
                        // }
                    }
                });
            },
            getChild(id) {
                this.category_id_1 = id;
                this.isshow = false;
                this.category_id = id;
                this.attr_id = '';
                getMenuList({
                    pid: id
                }).then(res => {
                    if(res.code == 0) {
                        this.childList = res.data;
                    }
                });
                this.getsupplyPage();
            },
            getAttr(category_id, attr_class_id) {
                this.attr_id = '';
                this.category_id = category_id;
                this.getsupplyPage();
                getAttrValueList({
                    attr_class_id: attr_class_id
                }).then(res => {
                    if(res.code == 0) {
                        this.attrList = res.data;
                        if(this.attrList.length>0) {
                            this.isshow = true;
                        }
                    }
                });
            },
            changeAttr(id) {
                this.attr_id = id;
                this.getsupplyPage();
            },
            changeArea(id) {
                this.areacode = id;
                this.getsupplyPage();
            },
            alltypes() {
                this.category_id = '';
                this.category_id_1 = '';
                this.attr_id = '';
                this.childList = [];
                this.attrList = [];
                this.isshow = false;
                this.getsupplyPage();
            }
        },
    }
</script>
